const React = require('react')
const { useState, useEffect } = require('react')
const { useHistory } = require('react-router-dom')
const { Card, CardHeader, CardBody, Collapse, FormGroup, Input, UncontrolledTooltip } = require('reactstrap')
const { useBlockchainData } = require('@hooks')
const { useNetworkConfig } = require('@contexts')

require('@styles/pages/verifyContract/index.css')

const Constructor = () => {
    const history = useHistory()
    const { network } = useNetworkConfig()
    const { getConstructor } = useBlockchainData(network.name)

    const params = new URLSearchParams(location.search)
    const [address, setAddress] = useState(params.get('a') ? params.get('a').toLowerCase() : null)
    const [constructorArguments, setConstructorArguments] = useState(null)
    const [isConstructorArgumentsOpen, setIsConstructorArgumentsOpen] = useState(true)

    const handleConstructorArgumentsChange = e => {
        const value = e.target.value
        setConstructorArguments(value)
    }

    useEffect(() => {
        const fetchData = async () => {
            try {
                const [constructorResponse] = await Promise.all([getConstructor(address)])

                if (constructorResponse) {
                    setConstructorArguments(constructorResponse.constructor)
                }
            } catch (error) {
                console.error('Error fetching data:', error)
            }
        }
        fetchData()
    }, [address])

    return (
        <Card className='box table-section' style={{ padding: '0px', border: 'none' }}>
            <CardHeader
                className='verify-card-header cursor-pointer'
                onClick={() => setIsConstructorArgumentsOpen(!isConstructorArgumentsOpen)}
                style={{
                    border: !isConstructorArgumentsOpen && 'none',
                    borderColor: isConstructorArgumentsOpen && 'var(--dropdown-background)'
                }}
            >
                <div>
                    <div style={{ fontWeight: 'bold' }}>
                        Constructor Arguments&nbsp;
                        <span
                            className={`${network.name}-text-color cursor-pointer`}
                            onClick={() =>
                                window.open('https://docs.soliditylang.org/en/develop/abi-spec.html', '_blank')
                            }
                        >
                            ABI-encoded
                        </span>
                    </div>
                    <div style={{ fontSize: '12px', color: 'var(--grey-color)' }}>
                        For contracts that were created with constructor parameters
                    </div>
                </div>
                <i className={`fas fa-angle-${isConstructorArgumentsOpen ? 'up' : 'down'}`} />
            </CardHeader>
            <Collapse isOpen={isConstructorArgumentsOpen}>
                <CardBody>
                    <FormGroup>
                        <Input
                            id='constructor-arguments'
                            type='textarea'
                            rows='10'
                            value={constructorArguments}
                            onChange={handleConstructorArgumentsChange}
                            style={{
                                border: 'none',
                                whiteSpace: 'pre-wrap',
                                wordWrap: 'break-word',
                                overflowX: 'hidden',
                                resize: 'vertical',
                                backgroundColor: 'var(--dropdown-background)',
                                color: 'var(--white-color)'
                            }}
                        />
                    </FormGroup>
                    <UncontrolledTooltip placement='top' target={`constructor-arguments`}>
                        This option ONLY applies to contract that accept constructor arguments, if you are unsure, you
                        most likely dont need this. The constructor arguments that should be in ABI-ENCODED values and
                        will be appended to the contract bytecode.
                    </UncontrolledTooltip>
                    <span style={{ fontSize: '12px', color: 'var(--grey-color)' }}>
                        For additional information on Constructor Arguments,&nbsp;
                        <span
                            className={`${network.name}-text-color cursor-pointer`}
                            onClick={() => history.push(`/${network.name}/contract-verification-constructor-arguments`)}
                        >
                            see our KB entry
                        </span>
                    </span>
                    .
                </CardBody>
            </Collapse>
        </Card>
    )
}

module.exports = { Constructor }
